import { Employees as EmployeesWebsite } from "pages/web/timekeeper/subpages/employees/Employees";
import { Employees as EmployeesMobile } from "pages/web/timekeeper/subpages/employees/Employees";
import { Scheduler as SchedulerWebsite } from "pages/web/timekeeper/subpages/scheduler/Scheduler";
import { Scheduler as SchedulerMobile } from "pages/web/timekeeper/subpages/scheduler/Scheduler";
import { Timecard as TimecardWebsite } from "pages/web/timekeeper/subpages/timecard/Timecard";
import { Timecard as TimecardMobile } from "pages/web/timekeeper/subpages/timecard/Timecard";
import { CustomReports as CustomReportsWebsite } from "pages/web/customReports/CustomReports";
import { CustomReports as CustomReportsMobile } from "pages/web/customReports/CustomReports";
import { Resume as ResumeWebsite } from "pages/web/timekeeper/subpages/resume/Resume";
import { Resume as ResumeMobile } from "pages/web/timekeeper/subpages/resume/Resume";

const gettingSubPage = (subPage, mobile) => {
    switch (subPage) {
        case 'resume':
            return mobile ? <ResumeMobile /> : <ResumeWebsite />;

        case 'employees':
            return mobile ? <EmployeesWebsite /> : <EmployeesMobile />;

        case 'scheduler':
            return mobile ? <SchedulerWebsite /> : <SchedulerMobile />;

        case 'timecard':
            return mobile ? <TimecardWebsite /> : <TimecardMobile />;

        case 'custom_reports':
            return mobile ? <CustomReportsWebsite /> : <CustomReportsMobile />;

        default:
            return <> {`404 Subpage ${subPage} not found`} </>
    }
}

export { gettingSubPage };